import React from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import Panel from '@adsk/alloy-react-panel';
import { WithAlloySuspense } from '@adsk/alloy-react-suspense';

import { useTranslation } from './i18n';

type FiltersHeaderProps = {
  onClose?: () => void;
  title?: string;
  floatingPanel?: boolean;
  clearFilters?: () => void;
  hasFilters?: boolean;
};
/**
 * A filters panel header.
 * @returns {*}
 */
const FiltersHeader = React.forwardRef<HTMLDivElement, FiltersHeaderProps>(
  ({ onClose, title, floatingPanel, clearFilters, hasFilters }, ref) => {
    const { t } = useTranslation();
    return (
      <Panel.Header
        ref={ref}
        onClose={onClose}
        title={title}
        renderActions={() =>
          floatingPanel ? (
            <LinkButton
              onClick={clearFilters}
              disabled={!hasFilters}
              style={{
                marginRight: 10,
              }}
            >
              {t('CLEAR_FILTERS')}
            </LinkButton>
          ) : null
        }
      />
    );
  },
);

FiltersHeader.displayName = 'FiltersHeader';

export default WithAlloySuspense(FiltersHeader);
